export default __webpack_public_path__ + "static/media/key2.5e26268c.jpg";